export const UtilidadesDomesticasIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8337 16.6694H16.8084C17.242 16.6694 17.6032 16.3371 17.6392 15.905L18.3339 7.5682C18.3533 7.33586 18.2745 7.10604 18.1166 6.93447C17.9588 6.76291 17.7363 6.66528 17.5031 6.66528H7.49902"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.66633 14.1685H2.83073C2.43334 14.1685 2.09118 14.449 2.01324 14.8386L1.67977 16.506C1.63079 16.7509 1.69419 17.0049 1.85254 17.198C2.01089 17.3912 2.2475 17.5032 2.49725 17.5032H9.9998C10.2496 17.5032 10.4862 17.3912 10.6445 17.198C10.8029 17.0049 10.8663 16.7509 10.8173 16.506L10.4838 14.8386C10.4059 14.4489 10.0637 14.1685 9.66633 14.1685Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8358 6.6653V5.77677C15.8358 4.16527 14.5294 2.85889 12.9179 2.85889V2.85889C11.3064 2.85889 10 4.16527 10 5.77677V6.6653"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.24857 1.66321V1.66321C6.93921 1.66321 7.49909 2.22309 7.49909 2.91373V13.7516C7.49909 13.9818 7.31246 14.1684 7.08225 14.1684H5.41489C5.18467 14.1684 4.99805 13.9818 4.99805 13.7516V2.91373C4.99805 2.22309 5.55792 1.66321 6.24857 1.66321Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
